import React, { useState, useEffect } from "react";
import Select from "react-select";
import FormField from "../components/common/FormField";
import PasswordField from "../components/common/PasswordField";
import { STATE_AREA_CODES } from "../utils/constants";
import { useNavigate } from 'react-router-dom';
import HeaderSign from "../components/signupHeader";
import { 
  validateName, 
  validateEmail, 
  validatePassword, 
  validateConfirmPassword, 
  validatePhoneNumber,
  calculatePasswordStrength 
} from "../utils/validators";
import { formatPhoneNumber } from "../utils/formatters";
import { signup } from "./../api/auth/auth";
function Signup() {
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [phonePrefix, setPhonePrefix] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [firstNameError, setFirstNameError] = useState("");
  const [lastNameError, setLastNameError] = useState("");
  const [emailError, setEmailError] = useState("");
  const [passwordError, setPasswordError] = useState("");
  const [confirmPasswordError, setConfirmPasswordError] = useState("");
  const [phoneNumberError, setPhoneNumberError] = useState("");
  const [passwordStrength, setPasswordStrength] = useState(0);
  const [isFormValid, setIsFormValid] = useState(false);
  const [signupError, setsignupError] = useState("");
  const navigate = useNavigate();

  // Handle blur events
  const handleFirstNameBlur = (e) => {
    setFirstNameError(validateName(e.target.value, "First name"));
  };

  const handleLastNameBlur = (e) => {
    setLastNameError(validateName(e.target.value, "Last name"));
  };

  const handleEmailBlur = (e) => {
    setEmailError(validateEmail(e.target.value));
  };

  const handlePasswordChange = (e) => {
    const value = e.target.value;
    setPassword(value);
    setPasswordStrength(calculatePasswordStrength(value));
  };

  const handlePasswordBlur = (e) => {
    const value = e.target.value;
    setPasswordError(validatePassword(value));
  };

  const handleConfirmPasswordBlur = (e) => {
    setConfirmPasswordError(validateConfirmPassword(e.target.value, password));
  };

  const handlePhoneNumberBlur = (e) => {
    setPhoneNumberError(validatePhoneNumber(e.target.value));
  };

  // Format phone number input
  const handlePhoneNumberChange = (e) => {
    setPhoneNumber(formatPhoneNumber(e.target.value));
  };

  // Check form validity
  useEffect(() => {
    const isValid =
      firstName &&
      lastName &&
      email &&
      password &&
      confirmPassword &&
      !firstNameError &&
      !lastNameError &&
      !emailError &&
      !passwordError &&
      !confirmPasswordError &&
      (!phoneNumber || !phoneNumberError);
    setIsFormValid(isValid);
  }, [
    firstName,
    lastName,
    email,
    password,
    confirmPassword,
    phoneNumber,
    firstNameError,
    lastNameError,
    emailError,
    passwordError,
    confirmPasswordError,
    phoneNumberError,
  ]);

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (isFormValid) {
      console.log("aaaaaaaaaaaaaaaaaaaaaaaaaa");
      const result = await signup({firstname:firstName,lastname:lastName,email:email,password:password,
        
        
        ...(phoneNumber?.trim() // check if not empty
        ? { phoneNumber: `${phonePrefix}${phoneNumber.replace("-", "")}` }
        : {}),})
      if (result.Errormessage){
        setsignupError(result.Errormessage)
      }else{
        navigate('/login', { replace: true });
      }
      // TODO: Send data to Django backend
    }
  };


 const handleLogin = ()=>{
  navigate("/login", {replace : true});
 }
  // Handle phone prefix change with debug log
  const handlePhonePrefixChange = (selectedOption) => {
    const newPrefix = selectedOption ? selectedOption.value : "";
    setPhonePrefix(newPrefix);
  };

  // Get selected option for react-select
  const getSelectedOption = () => {
    if (!phonePrefix) return null;
    const selected = STATE_AREA_CODES.find((opt) => opt.code === phonePrefix);
    return selected ? { value: selected.code, label: selected.code } : null;
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <HeaderSign/>
    <div className="min-h-screen bg-gray-100 flex items-center justify-center p-4">
      <div className="w-full max-w-md bg-white rounded-lg p-6" style={{ boxShadow: '0 8px 12px 4px rgba(147, 197, 253, 0.3)' }}>
        <h2 className="text-2xl font-bold text-gray-900 mb-4 text-center">Sign Up</h2>
        <form className="space-y-3" onSubmit={handleSubmit}>
                      <FormField
              label="First Name"
              value={firstName}
              onChange={(e) => setFirstName(e.target.value)}
              onBlur={handleFirstNameBlur}
              error={firstNameError}
              placeholder="Enter your first name"
              required
            />
                      <FormField
              label="Last Name"
              value={lastName}
              onChange={(e) => setLastName(e.target.value)}
              onBlur={handleLastNameBlur}
              error={lastNameError}
              placeholder="Enter your last name"
              required
            />
                      <FormField
              label="Email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              onBlur={handleEmailBlur}
              error={emailError}
              placeholder="Enter your email"
              required
            />
                      <PasswordField
              label="Password"
              value={password}
              onChange={handlePasswordChange}
              onBlur={handlePasswordBlur}
              error={passwordError}
              placeholder="Enter your password"
              required
              showStrength
              strength={passwordStrength}
            />
                      <PasswordField
              label="Confirm Password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              onBlur={handleConfirmPasswordBlur}
              error={confirmPasswordError}
              placeholder="Confirm your password"
              required
            />
          <div>
            <label htmlFor="phone" className="block text-sm font-medium text-gray-700 mb-1">
              Phone Number (Optional)
            </label>
            <div className="flex space-x-2 items-center">
              <div className="w-1/2">
                <Select
                  options={STATE_AREA_CODES.map((opt) => ({
                    value: opt.code,
                    label: `${opt.state} ${opt.code}`,
                  }))}
                  value={getSelectedOption()}
                  onChange={handlePhonePrefixChange}
                  className="text-sm"
                  menuPlacement="top"
                  styles={{
                    control: (base) => ({
                      ...base,
                      height: "42px",
                      minHeight: "42px",
                      border: "1px solid #d1d5db",
                      borderRadius: "0.375rem",
                      padding: "0 12px",
                      fontSize: "0.875rem",
                      whiteSpace: "nowrap", // Prevent wrapping
                      "&:hover": { borderColor: "#3b82f6" },
                      boxShadow: "none",
                    }),
                    menu: (base) => ({
                      ...base,
                      marginBottom: 2,
                      marginTop: 0,
                      borderRadius: "0.375rem",
                      boxShadow: "0 -1px 3px rgba(0,0,0,0.1)",
                      width: "100%",
                      zIndex: 10,
                    }),
                    menuList: (base) => ({
                      ...base,
                      maxHeight: "180px",
                      overflowY: "auto",
                      padding: "4px 0",
                    }),
                    option: (base, { isFocused, isSelected }) => ({
                      ...base,
                      fontSize: "0.875rem",
                      padding: "4px 12px",
                      lineHeight: "1.25",
                      backgroundColor: isSelected
                        ? "#2563eb"
                        : isFocused
                        ? "#dbeafe"
                        : "white",
                      color: isSelected ? "white" : "#374151",
                      cursor: "pointer",
                    }),
                    singleValue: (base) => ({
                      ...base,
                      color: "#374151",
                      whiteSpace: "nowrap", // Prevent wrapping of selected value
                    }),
                    placeholder: (base) => ({
                      ...base,
                      color: "#9ca3af",
                      whiteSpace: "nowrap", // Prevent wrapping of placeholder
                    }),
                  }}
                  placeholder="Select State"
                />
              </div>
              <input
                type="tel"
                id="phoneNumber"
                placeholder="Enter your phone number"
                value={phoneNumber}
                onChange={handlePhoneNumberChange}
                onBlur={handlePhoneNumberBlur}
                className={`w-1/2 text-sm text-gray-700 border ${
                  phoneNumberError ? "border-red-500" : "border-gray-300"
                } rounded-md h-10 py-2 px-3 focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500`}
              />
            </div>
            {phoneNumberError && <p className="text-red-500 text-xs mt-1">{phoneNumberError}</p>}
          </div>
          <div className="flex justify-between mt-1">
                <button
                  type="button"
                  onClick={handleLogin}
                  className="text-sm text-blue-600 hover:text-blue-800 hover:underline focus:outline-none"
                >
                  Already signed up?
                </button>
          </div>
          <button
            type="submit"
            disabled={!isFormValid}
            className={`w-full py-2 px-4 rounded-md font-semibold text-sm text-white transition-colors ${
              isFormValid
                ? "bg-blue-600 hover:bg-blue-700"
                : "bg-gray-400 cursor-not-allowed"
            }`}
          >
            Sign Up

          </button>
          {signupError && <p className="text-red-500 text-xs mt-1">{signupError}</p>}

        </form>
      </div>
    </div>
    </div>
  );
}

export default Signup;